<template>
    <v-card>
        <v-data-table
            :loading="reportTableLoading"
            :headers="headers"
            :items="pointOfSaleReportData"
            :server-items-length="total"
            :options.sync="options"
            :hide-default-footer="hideFooter"
            :footer-props="getFooterProps()"
        >
            <template v-slot:item.avgBookingDaysInAdvance="{item}">
                {{ parseFloat(item.avgBookingDaysInAdvance).toFixed(1) + (item.avgBookingDaysInAdvance >= 2 ? ' dias' : ' dia') }}
            </template>
            <template v-slot:item.avgBookedDays="{item}">
                {{ parseFloat(item.avgBookedDays).toFixed(1) }}
            </template>
            <template v-slot:item.avgDailyRate="{item}">
                {{ getValueInReais(item.avgDailyRate) }}
            </template>
            <template v-slot:item.totalAmount="{item}">
                {{ getValueInReais(item.totalAmount) }}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: "PointOfSaleReportTable",

    props: {
        limit: {
            type: Number,
            required: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        hideQuery: {
            type: Boolean,
            default: false,
        }
    },

    data: () => ({
        pointOfSaleReportData: [],
        total: 0,
        reportTableLoading: true,
        query: '',
        filter: {},
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Código', value: 'point_of_sale.id', sortable: false},
            {text: 'Ponto de Venda', value: 'point_of_sale.name', sortable: false},
            {text: 'Qtd de Reservas Confirmadas', value: 'totalBookings', sortable: true},
            {text: 'Antecedência de realização da reserva (média)', value: 'avgBookingDaysInAdvance', sortable: true},
            {text: 'Diárias (média)', value: 'avgBookedDays', sortable: true},
            {text: 'Valor da Diária (média)', value: 'avgDailyRate', sortable: true},
            {text: 'Valor Total', value: 'totalAmount', sortable: true},
        ]
    }),

    methods: {
        getValueInReais(value) {
            return 'R$ ' + (value / 100).toFixed(2);
        },

        pushQueryToRouter() {
            if (!this.hideQuery) {
                this.$router.push({
                    query: {
                        'page': this.options.page,
                        'perPage': this.options.itemsPerPage,
                        'sortBy': this.options.sortBy,
                        'sortDesc': this.options.sortDesc,
                        'pointOfSaleId': this.filter.pointOfSaleId,
                        'pointOfSaleName': this.filter.pointOfSaleName,
                        'bookingStartDate': this.filter.bookingStartDate,
                        'bookingUntilDate': this.filter.bookingUntilDate,
                    }
                });
            }
        },

        setQueryString() {
            this.query = `sortBy=${this.options.sortBy}&page=${this.options.page}&sortDesc=${this.options.sortDesc}&perPage=${this.options.itemsPerPage}&limit=${this.limit ?? ''}` +
                `&pointOfSaleId=${this.filter.pointOfSaleId}&pointOfSaleName=${this.filter.pointOfSaleName}` +
                `&bookingStartDate=${this.filter.bookingStartDate}&bookingUntilDate=${this.filter.bookingUntilDate}`
        },

        setFilter(filter) {
            this.filter = {
                'pointOfSaleId': filter.pointOfSaleId ?? '',
                'pointOfSaleName': filter.pointOfSaleName ?? '',
                'bookingStartDate': filter.bookingStartDate ?? filter.startDate ?? '',
                'bookingUntilDate': filter.bookingUntilDate ?? filter.finalDate ?? '',
            };
        },

        getReportData(filter = {}) {
            this.reportTableLoading = true;
            this.setFilter(filter);
            this.setQueryString();
            this.pushQueryToRouter();
            axios.get( `/api/reports/point-of-sale?${this.query}`)
                .then(res => {
                    this.pointOfSaleReportData = res.data.data;
                    this.total = res.data.total;
                    this.reportTableLoading = false;
                });
        },

        getFooterProps() {
            if (this.hideFooter) {
                return {itemsPerPageOptions: [10]};
            }
            return {itemsPerPageOptions: [10, 15, 30]};
        },

        getOptionsFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    page,
                    perPage,
                    sortBy,
                    sortDesc,
                } = this.$route.query;
                if (page) {
                    this.options.page = parseInt(page ? page : 1);
                }
                if (perPage) {
                    this.options.itemsPerPage = perPage;
                }
                if (sortBy) {
                    this.options.sortBy = sortBy;
                }
                if (sortDesc) {
                    this.options.sortDesc = sortDesc;
                }
            }
        },
    },

    mounted() {
        this.getOptionsFromUrlQuery();
    },

    watch: {
        options: {
            handler: function() {
                if (!this.hideQuery) {
                    this.getReportData(this.filter);
                }
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
